import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import { sentinelModule } from "../modules/sentinelModule";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import { customDimensions_template } from "../components/templates/customDimensions_template";

declare var ko: any;
declare var page: any;

export class customDimensions extends sentinelModule {

    protected XHRHdl: XMLHttpRequestHandler;
    protected customDimensions_template: customDimensions_template;

    protected getModuleName(): string {
        return "customDimensions";
    }

    public buildContent(): Array<Element> {

        const parentContent = super.buildContent();

        // create validation errors list template
        this.customDimensions_template = new customDimensions_template('customDimensions', this.viewModel, this);

        return [...parentContent, this.customDimensions_template.build()];
    }

    fillPage() : void {

        this.getPermissions();
        this.getFormData();
    }

    public filterSimpleCancel(){}

    public filterSimpleOnChange() {
        this.getFormData();
    }

    protected onSubmitEdit(){

        this.loadingIn(this.customDimensions_template.builtTemplate.querySelector("#customDimensions-results"));

        let subViewModel = this.customDimensions_template.getViewModelForRequest();

        let customDimensionsReq_url: string = '/api/settings/customDimensions/update/';
        let customDimensionsReq_params: Array<Array<string>> = [];
        customDimensionsReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(customDimensionsReq_url, customDimensionsReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onUpdateDimensionsReturn;
        this.XHRHdl.execute();
    }

    protected onSubmitCreate(){

        this.loadingIn(this.customDimensions_template.builtTemplate.querySelector("#customDimensions-results"));

        let subViewModel = this.customDimensions_template.getViewModelForRequest();

        let customDimensionsReq_url: string = '/api/settings/customDimensions/create/';
        let customDimensionsReq_params: Array<Array<string>> = [];
        customDimensionsReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(customDimensionsReq_url, customDimensionsReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;

        this.XHRHdl.onReadyStateFunction = this.onUpdateDimensionsReturn;
        this.XHRHdl.execute();
    }

    //
    // obtain the dynamic data required to fill the formulary
    protected getFormData(){

        this.loadingIn(this.customDimensions_template.builtTemplate.querySelector("#customDimensions-results"));

        let subViewModel = this.customDimensions_template.getViewModelForRequest();

        let customDimensionsReq_url: string = '/api/settings/customDimensions/getAll/';
        let customDimensionsReq_params: Array<Array<string>> = [];
        customDimensionsReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdl = new XMLHttpRequestHandler(customDimensionsReq_url, customDimensionsReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetFormDataReturn;
        this.XHRHdl.execute();
    }

    protected getPermissions(){

        this.loadingIn(this.customDimensions_template.builtTemplate.querySelector("#customDimensions-results"));

        let accPermissions_url: string = '/api/settings/menuData';
        let accPermissions_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(accPermissions_url, accPermissions_params, this);

        this.XHRHdl.onReadyStateFunction = this.onGetPermissionsReturn;
        this.XHRHdl.execute();
    }

    protected onGetPermissionsReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                obj.customDimensions_template.setSideMenuPermissionsData(responseParsed);
            })

            obj.loadingOut(obj.customDimensions_template.builtTemplate.querySelector("#customDimensions-results"));
        }
    }
    
    protected onGetFormDataReturn(req, obj){

        return function () {

            obj.manageResponse(req, obj, function () {

                let responseParsed = JSON.parse(req.request.response);

                let vnApp = obj.getVnAppZone().app;
                let loggedUserId = vnApp.loggedUser.user.id;

                obj.customDimensions_template.setCustomDimensions(responseParsed);
            });

            // LOADING : ends
            obj.loadingOut(obj.customDimensions_template.builtTemplate.querySelector("#customDimensions-results"));
        }
    }

    protected onUpdateDimensionsReturn(req, obj){
        
        return function () {

            obj.manageResponse(req, obj, function () {

                obj.customDimensions_template.clearErrors();

                let responseParsed = JSON.parse(req.request.response);

                let vnApp = obj.getVnAppZone().app;
                let loggedUserId = vnApp.loggedUser.user.id;

                // custom error handling
                if (responseParsed.nameError) {

                    obj.customDimensions_template.getTemplateViewModel().nameError(responseParsed.nameError)
                } else if (responseParsed.descriptionError) {
                
                    obj.customDimensions_template.getTemplateViewModel().descriptionError(responseParsed.descriptionError)
                } else if (responseParsed.generalError) {
                
                    obj.customDimensions_template.getTemplateViewModel().generalError(responseParsed.generalError)
                } else {
                    
                    // success
                    obj.customDimensions_template.setCustomDimensions(responseParsed);
                    obj.customDimensions_template.onCloseCreate();
                    obj.customDimensions_template.onCloseEdit();

                    let notifMessage = '';

                    if (req.url.includes('/create/')) {
    
                        notifMessage = "Dimension has been added successfully. Please update your tracking code accordingly.";                    
                    } else if (req.url.includes('/update/')) {
    
                        notifMessage = "Dimension has been updated successfully. Please update your tracking code accordingly.";                    
                    }

                    obj.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, notifMessage);
                    obj.getVnAppZone().showNotificationToModule();
                }

                obj.loadingOut(obj.customDimensions_template.builtTemplate.querySelector("#customDimensions-results"));
            });

        }
    }
}


// WEBPACK FOOTER //
// ./js/modules/customDimensions.ts